import React, { useState } from 'react'
import "../../styles/landing/doctorLanding.scss"
import { useParams } from 'react-router-dom';
// /styles/landing/doctorLanding.scss
// import { LoginForm } from 'components/forms/register/native/LoginForm'
import Loading from 'components/Loading';
import { useDispatch } from 'react-redux';
import Notificacion from 'components/ui/Notificacion';
import { confirmDeleteAccountByUserId } from 'redux/actions/aLogin';


export const DeleteAccount = () => {

  let { clientId } = useParams();
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await dispatch(confirmDeleteAccountByUserId(clientId));
      setLoading(false);
      if (response.transaccion) setSuccess(true);

    } catch (error) {
      setLoading(false);
      Notificacion({
        type: "error",
        text: 'Ocurrio un error, intente nuevamente',
      });
    }

  }

  return (

    <div className='doctor-landing-page'>
      <div id="form" className="form odd" style={{ marginTop: '10px' }}>
        {/* <LoginForm deleteAccount title='Debes ingresar tus datos para confirmar la eliminación de tu cuenta.'/> */}
        <Loading loading={loading} title='Eliminando cuenta de usuario...'>
          <>
            {
              !success ?
                <div>
                  <h1>Eliminar cuenta</h1>
                  <p>Estas por eliminar tu cuenta Medpal. Selecciona confirmar para realizar la eliminación</p>
                  <button className="registrarse" onClick={handleDelete}>Confirmar</button>
                </div>
                :
                <div>
                  <h1>Eliminación de cuenta</h1>
                  <h3>
                    Su cuenta ha sido eliminada correctamente
                  </h3>
                </div>
            }

            {/* Success */}
          </>

        </Loading>
      </div>
    </div>

  )
}
